import * as z from "zod";

export const alertRecoverSlack = {
  name: "alertRecoverSlack" as const,
  input: z.object({
    teamId: z.string(),
    teamName: z.string().optional(),
    conversationId: z.string(),
    reason: z.string().optional(),
    userIds: z.array(z.string()).optional(),
    authEmail: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
